<template>
    <div class="professional-review-status-wrap">
        <span class="professional-item-status" :class="className">{{ label }}</span>
        <small v-if="item.reviewReason">驳回原因：{{ item.reviewReason }}</small>
    </div>
</template>

<script>
export default {
    name: "ProfessionalApplicationReviewStatus",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        className() {
            if (Number(this.item.reviewStatus) === 2) return "approved";
            if (Number(this.item.reviewStatus) === 3) return "rejected";
            return "review";
        },
        label() {
            if (this.item.reviewStatusDescription) return this.item.reviewStatusDescription;
            if (Number(this.item.reviewStatus) === 2) return "已通过";
            if (Number(this.item.reviewStatus) === 3) return "已驳回";
            return "待审核";
        },
    },
};
</script>
